import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
const fullWidthStyles = css `
	width: 100%;
`;
/**
 * Note the iframe created in this component is dependent on the embedIFrame function being
 * called to be size correctly.
 * src/web/browser/embedIframe/embedIframe.ts
 */
export const InstagramBlockComponent = ({ element, index }) => {
    return (_jsx("iframe", { css: fullWidthStyles, className: "js-embed__iframe", name: `instagram-embed-${index}`, "data-cy": "instagram-embed", title: `Instagram Post ${index}`, srcDoc: `${element.html}
			<script src="https://interactive.guim.co.uk/libs/iframe-messenger/iframeMessenger.js"></script>
			<gu-script>iframeMessenger.enableAutoResize();</gu-script>` }, void 0));
};
